export const FORMS_DEFAULT_VALUE_SELECT = 'FORMS/DEFAULT_VALUE_SELECT'
export const FORMS_SHOW_PASSWORD = 'FORMS/SHOW_PASSWORD'